// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zEauC","maxWidthContainer":"styles_maxWidthContainer__ICXHU","left":"styles_left__xA+ro","right":"styles_right__9DRTR"};